import React, { useState } from 'react'
import Alert from '../../components/alert'
import PropTypes from 'prop-types'
import APIRequest from '../../helpers/apiHelpers'

import Button from '../button'
import { toast } from 'react-toastify'

function StripeCheckoutButton ({
  apiBaseUrl,
  depositPayableOnline,
  clientId,
  auctionId,
  userId,
  id,
  block = true,
  color = 'primary',
  className,
  style,
  children,
  ...rest
}) {
  const [loading, setLoading] = useState(false)

  const handleClick = async () => {
    if (loading) return
    setLoading(true)
    const referer = encodeURIComponent(window.location.href)
    await APIRequest.get(apiBaseUrl, clientId, `createStripeCheckoutSession/${auctionId}?referer=${referer}`)
      .then(res => {
        window.location.href = res.body.redirectUrl
      })
      .catch(err => {
        console.error(err.message)
        toast.error(JSON.parse(err.message).message)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    depositPayableOnline
      ? <Button
        block={block}
        className={className}
        color={color}
        disabled={loading}
        id={id}
        onClick={handleClick}
        style={style}
        type='button'
        {...rest}
      >
        {children}
      </Button>
      : <Alert color='warning' className='text-center stripe-checkout-alert'>{children}</Alert>
  )
}

StripeCheckoutButton.propTypes = {
  apiBaseUrl: PropTypes.string.isRequired,
  depositPayableOnline: PropTypes.bool.isRequired,
  clientId: PropTypes.string.isRequired,
  auctionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  id: PropTypes.string,
  block: PropTypes.bool,
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node.isRequired
}

StripeCheckoutButton.defaultProps = {
  block: true
}

export default StripeCheckoutButton
